import { render, staticRenderFns } from "./Riwayathidup.vue?vue&type=template&id=a13403b8"
import script from "./Riwayathidup.vue?vue&type=script&lang=js"
export * from "./Riwayathidup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports